import {
    GETKYCCONFIGURATIONID_SUCCESS,
    GETKYCCONFIGURATIONID_FAILED,
    RESET_GETKYCCONFIGURATIONID,
    LOADING_GETKYCCONFIGURATIONID,
    NETWORK_ERROR_GETKYCCONFIGURATIONID
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETKYCCONFIGURATIONID:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETKYCCONFIGURATIONID_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETKYCCONFIGURATIONID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETKYCCONFIGURATIONID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETKYCCONFIGURATIONID:
            return (state = initialState);
        default:
            return state;
    }
};
